import { useAuth0 } from '@auth0/auth0-react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import { useAppSelector } from 'core/store/hooks';
import AppInDevelopmentNotice from './AppInDevelopmentNotice/AppInDevelopmentNotice';
import CheckExampleClaims from './CheckExampleClaims/CheckExampleClaims';
import SingleClaim from './Claim/SingleClaim';
import Claims from './Claims';
import ErrorComponent from './ErrorDescriptionComponent';
import Header from './Header';
import useScrollToClaims from './hooks/useScrollToClaim';
import NoSourcesFoundComponent from './NoSourcesFoundComponent';
import SearchField from './SearchField';
import SuggestedClaimButtons from './SuggestedClaimButtons';
import Summary from './Summary';
import RelatedSearches from './RelatedSearches/RelatedSearches';
import WelcomeNotice from './WelcomeNotice/WelcomeNotice';
import { useEffect, useState } from 'react';

const PlaygroundV2Page = () => {
  const claim = useAppSelector((state) => state.claimsV2.claims[0]);
  const claims = useAppSelector((state) => state.claimsV2.claims);
  const isClaimLoading = useAppSelector((state) => state.claimsV2.isClaimLoading);
  const hasError = useAppSelector((state) => state.claimsV2.error);
  const suggestedSearches = useAppSelector(
    (state) => state.claimsV2.generatedClaimsForClaim?.[claim?.claim] || []
  );
  const claimHasEvidence = claim?.evidence && claim.evidence?.length > 0;
  const isNoDataFound = useAppSelector((state) => state.claimsV2.isNoDataFound);
  const { scrollTargetRef } = useScrollToClaims();
  const { isAuthenticated } = useAuth0();

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('desktop'));

  const hasSuggestedSearches = suggestedSearches && suggestedSearches.length > 0;
  const isSingleClaim = claims.length == 1;
  const [showWelcomeNotice, setShowWelcomeNotice] = useState(false);

  useEffect(() => {
    const hidden = localStorage.getItem('welcomePosterHidden') === 'true';
    setShowWelcomeNotice(!hidden);
  }, []);

  const handleHideWelcomeNotice = () => {
    localStorage.setItem('welcomePosterHidden', 'true');
    setShowWelcomeNotice(false);
  };

  return (
    <Box>
      {!isSmallScreen && <Header />}
      {!isAuthenticated && showWelcomeNotice && <WelcomeNotice onHide={handleHideWelcomeNotice} />}
      <SearchField />
      {!(isClaimLoading || claimHasEvidence) && isAuthenticated && <AppInDevelopmentNotice />}
      {/* show related searches for single claims */}
      {!isClaimLoading && hasSuggestedSearches && isSingleClaim && (
        <RelatedSearches suggestedSearches={suggestedSearches} />
      )}
      {/* show when there is no evidence was found */}
      {!isClaimLoading && isNoDataFound && isSingleClaim && <NoSourcesFoundComponent />}
      {/* show when there is an encounter of error */}
      {!isClaimLoading && hasError && <ErrorComponent />}
      {/* show when there is no data and not loading */}
      {!isClaimLoading && !claimHasEvidence && isAuthenticated && <SuggestedClaimButtons />}
      {/* show summary when there is data and loading for single claim */}
      {(isClaimLoading || claimHasEvidence) && isSingleClaim && (
        <Summary isLoading={isClaimLoading} claim={claim} />
      )}
      {/* show when there is data and not loading for single claim */}
      {!isClaimLoading && claimHasEvidence && isSingleClaim && (
        <Box ref={scrollTargetRef}>
          <SingleClaim />
        </Box>
      )}
      {/* show when there is data and not loading for full text */}
      {!isClaimLoading && !isSingleClaim && <Claims scrollTargetRef={scrollTargetRef} />}
      {/* show when user is not logged in and no test claim is being searched */}
      {!isAuthenticated && !claimHasEvidence && <CheckExampleClaims />}
    </Box>
  );
};

export default PlaygroundV2Page;
